import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useSuppliersApi } from "../../http/suppliers/api";
import HistoryDialog from "../ui/HistoryDialog";

import VersionDialog from "../ui/VersionDialog";

type SupplierHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const SupplierHistoryDialog: FC<SupplierHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const suppliersApi = useSuppliersApi();

  return (
    <HistoryDialog
      title={i18n.t.suppliers.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={suppliersApi.getAdminSupplierVersion}
      getHistory={suppliersApi.getAdminSupplierHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current.name != dataVersion.next.name && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.name}
                  value={dataVersion.current?.name}
                  edited={dataVersion.next.name}
                />
              </tr>
            )}
            {dataVersion.current.address != dataVersion.next.address && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.address}
                  value={dataVersion.current?.address}
                  edited={dataVersion.next.address}
                />
              </tr>
            )}
            {dataVersion.current.email != dataVersion.next.email && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.email}
                  value={dataVersion.current?.email}
                  edited={dataVersion.next.email}
                />
              </tr>
            )}
            {dataVersion.current.phoneNumber != dataVersion.next.phoneNumber && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.phoneNumber}
                  value={dataVersion.current?.phoneNumber}
                  edited={dataVersion.next.phoneNumber}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default SupplierHistoryDialog;
